import React from 'react';
import { Button, Form, Modal } from 'semantic-ui-react';

export default function NewFilterModal(
    props: {
        onCancel: () => void,
        onSubmit: (SyntheticEvent<HTMLFormElement>) => void,
        open: boolean
    } = { open: false }
) {
    return (
        <Modal open={props.open} size="small">
            <Modal.Header content="New Filter" />
            <Modal.Content>
                <Form id="form-new-filter" onSubmit={props.onSubmit}>
                    <p>{'Enter a name for this filter:'}</p>
                    <Form.Input autoFocus name="filterName" />
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button content="Cancel" onClick={props.onCancel} />
                <Button content="Save" form="form-new-filter" primary type="submit" />
            </Modal.Actions>
        </Modal>
    );
}



// WEBPACK FOOTER //
// ./components/molecules/NewFilterModal.jsx